import { UnstyledButton } from 'utils/fragments';
import styled from 'styled-components';

const OverviewCardWrapper = styled(UnstyledButton)`
    background-color: ${({ theme }) => theme.gray_7};
    color: ${({ theme }) => theme.gray_1};
    border-radius: ${({ theme }) => theme.borderRadius_lg};
    border: solid 1px ${({ theme }) => theme.gray_5};
    overflow: hidden;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
    position: absolute;
    inset: 0;
    min-width: -moz-available;
    padding: ${({ theme }) => `${theme.space_7}px 0 0`};
    outline-offset: 4px;
    &:hover,
    &:focus-visible {
        box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.2);
    }
    transition: all 100ms linear;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .sparkline-area {
        opacity: 0.75;
        transition: opacity 150ms ease;
    }
    &:hover .sparkline-area,
    &:focus-visible .sparkline-area {
        opacity: 1;
    }
`;

export default OverviewCardWrapper;
